
function ErrorNet({ close, msg }) {

    return (
        <>
            <div className="fixed top-0 left-0 w-screen h-screen bg-black opacity-40"></div>
            <div className="fixed top-[40%] left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-primary-100 h-2/5 rounded-lg px-20 py-14 flex flex-col justify-between items-center">
                <img src="/image/icon/errorNet.png" className="w-20" />
                <p className="text-xl font-bold text-redCustom-500">خطا در شبکه</p>
                <p className="rtol">متاسفانه اختلالی در شبکه موجود است لطفا مجدد تلاش نمایید.</p>
                <p className="text-slate-500 text-sm">{msg}</p>
                <button className="bg-redCustom-500 text-white font-bold w-full py-2 rounded" onClick={() => close(false)} >تلاش دوباره</button>
            </div>
        </>
    )
}
export default ErrorNet;